// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__33XDY","header":"ReportDetails_header__3mVVN","title":"ReportDetails_title__1Fe2g","left":"ReportDetails_left__3qEJ7"};